import { gql } from '@apollo/client';

export const GetFileUploadUrlQuery = gql`
  query GetFileUploadUrlQuery($filename: String!) {
    buyer {
      getFileUploadUrl(input: { filename: $filename }) {
        fileUpload {
          getUrl
          presignedPutUrl
          s3Key
        }
      }
    }
  }
`;
